var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50035 1C2.50035 1.28 2.72535 1.5 3.00035 1.5H5.79535L0.350352 6.945C0.155352 7.14 0.155352 7.455 0.350352 7.65C0.545352 7.845 0.860352 7.845 1.05535 7.65L6.50035 2.205V5C6.50035 5.275 6.72535 5.5 7.00035 5.5C7.27535 5.5 7.50035 5.275 7.50035 5V1C7.50035 0.725 7.27535 0.5 7.00035 0.5H3.00035C2.72535 0.5 2.50035 0.725 2.50035 1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.c61e918c74e7143285575e29cadc02d2.svg";
export { ForwardRef as ReactComponent };